// Helper simples para evitar erro de fuso horário UTC (YYYY-MM-DD caindo no dia anterior)
const parseDataLocal = (dataStr) => {
  if (!dataStr) return null;
  if (dataStr instanceof Date) return dataStr;
  const partes = String(dataStr).split("T")[0].split("-");
  if (partes.length === 3) {
    const [ano, mes, dia] = partes.map(Number);
    return new Date(ano, mes - 1, dia);
  }
  return new Date(dataStr);
};

const calcularDiasRestantes = (processo) => {
  const ultimaMovimentacao = processo?.ultimaMovimentacao;
  const prazos = ultimaMovimentacao?.prazos;
  const dataBruta =
    prazos?.dataPrazo ||
    prazos?.dataVencimento;
  if (!dataBruta) {
    return null;
  }

  const dataPrazo = parseDataLocal(dataBruta);
  if (!dataPrazo || Number.isNaN(dataPrazo.getTime())) {
    return null;
  }

  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);

  const dataPrazoComparacao = new Date(dataPrazo);
  dataPrazoComparacao.setHours(0, 0, 0, 0);

  const diffTempo =
    dataPrazoComparacao - hoje;

  return Math.ceil(
    diffTempo /
    (1000 * 60 * 60 * 24)
  );
};

const obterPrioridadeProcesso = (processo) => {
  const ultimaMovimentacao =
    processo?.ultimaMovimentacao;
  const prazos =
    ultimaMovimentacao?.prazos;
  const resolvido =
    prazos?.resolvido || false;

  if (resolvido) {
    return {
      diasRestantes: null,
      grupo: "resolvido",
      ordem: 9000,
      classe: "prioridade-resolvido"
    };
  }

  const diasRestantes =
    calcularDiasRestantes(processo);

  if (diasRestantes === null) {
    return {
      diasRestantes: null,
      grupo: "sem-prazo",
      ordem: 8000,
      classe: "prioridade-sem-prazo"
    };
  }

  // 1. Vencidos ficam em ordem 7000 (abaixo de qualquer vigente)
  if (diasRestantes < 0) {
    return {
      diasRestantes,
      grupo: "vencido",
      ordem: 7000,
      classe: "prioridade-vencido"
    };
  }

  // 2. HOJE: destaque e prioridade máxima (ordem 0)
  if (diasRestantes === 0) {
    return {
      diasRestantes,
      grupo: "hoje",
      ordem: 0,
      classe: "prioridade-1"
    };
  }

  // 3. Demais faixas preservadas com suas ordens e classes originais
  if (diasRestantes <= 3) {
    return {
      diasRestantes,
      grupo: "1-3",
      ordem: diasRestantes,
      classe: "prioridade-1"
    };
  }

  if (diasRestantes <= 6) {
    return {
      diasRestantes,
      grupo: "4-6",
      ordem: diasRestantes,
      classe: "prioridade-2"
    };
  }

  if (diasRestantes <= 10) {
    return {
      diasRestantes,
      grupo: "7-10",
      ordem: diasRestantes,
      classe: "prioridade-3"
    };
  }

  if (diasRestantes <= 15) {
    return {
      diasRestantes,
      grupo: "11-15",
      ordem: diasRestantes,
      classe: "prioridade-4"
    };
  }

  return {
    diasRestantes,
    grupo: "16+",
    ordem: diasRestantes,
    classe: "prioridade-5"
  };
};

const ordenarProcessosPorPrioridade = (processos) => {
  if (!Array.isArray(processos)) {
    return [];
  }
  return processos
    .map((processo, indiceOriginal) => ({
      processo,
      indiceOriginal,
      prioridade:
        obterPrioridadeProcesso(processo)
    }))
    .sort((a, b) => {
      if (
        a.prioridade.ordem !==
        b.prioridade.ordem
      ) {
        return (
          a.prioridade.ordem -
          b.prioridade.ordem
        );
      }
      return (
        a.indiceOriginal -
        b.indiceOriginal
      );
    })
    .map((item) => item.processo);
};

export {
  calcularDiasRestantes,
  obterPrioridadeProcesso,
  ordenarProcessosPorPrioridade
};

export default obterPrioridadeProcesso;